import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import {
	MEDIUMORANGE,
	WHITE,
	STRONGORANGE,
} from '../../../../styles/colors.style'

import FooterCard from '../../../../../assets/images/banners-cartao/big-card.png'

export const Footer = styled.footer`
	position: relative;
	display: flex;
	justify-content: flex-end;
	flex-direction: column;

	.customer-area {
		background: ${MEDIUMORANGE};
		display: flex;
		height: 414px;

		@media (min-width: ${breakpoints.MOBILE}px) {
			height: 320px;
		}

		.customer {
			position: relative;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			max-width: 1128px;
			width: 100%;

			@media (min-width: ${breakpoints.MOBILE}px) {
				flex-direction: row;
				align-items: center;
			}
		}
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
		height: 117px;
	}
`

export const Question = styled.p`
	width: 310px;
	margin: 0 auto 10px;
	padding: 0 10px;
	height: 42px;
	color: ${WHITE};
	background: ${STRONGORANGE};
	font-size: 29px;
	font-weight: bold;
	text-align: center;
	order: 1;

	@media (min-width: ${breakpoints.MOBILE}px) and (max-width: ${breakpoints.NOTEBOOK}px) {
		width: auto;
		margin: 0;
	}

	@media (min-width: ${breakpoints.NOTEBOOK}px) {
		width: auto;
		margin: 0 40px 0 0;
	}
`

export const ClickHere = styled.p`
	margin: 0 0 40px;
	padding: 0 20px;
	color: ${WHITE};
	font-size: 29px;
	font-weight: bold;
	text-align: center;
	text-transform: uppercase;
	line-height: 100%;
	order: 1;

	a span {
		text-decoration: underline;
		color: ${WHITE};
	}

	@media (min-width: ${breakpoints.NOTEBOOK}px) {
		text-transform: initial;
		margin: 0;
	}

	@media (min-width: ${breakpoints.MOBILE}px) and (max-width: ${breakpoints.NOTEBOOK}px) {
		text-transform: initial;
		margin: 0 0 0 3%;
	}
`

export const BigCard = styled.div`
	background: url(${FooterCard}) no-repeat;
	background-size: cover;
	width: 334px;
	height: 210px;
	order: 0;
	margin: -30px auto 20px;

	@media (min-width: ${breakpoints.NOTEBOOK}px) {
		position: absolute;
		right: 0;
		bottom: 30px;
		margin: 0;
	}

	@media (min-width: ${breakpoints.MOBILE}px) and (max-width: ${breakpoints.NOTEBOOK}px) {
		position: absolute;
		right: 0;
		bottom: 30px;
		margin: 0;
	}
`

export const Message = styled.div`
	background: ${STRONGORANGE};
	width: 100%;
	height: 65px;
	order: 1;

	a {
		display: block;
		color: ${WHITE};
		text-align: center;
		text-transform: uppercase;
		font-weight: 600;
		font-size: 24px;
		line-height: 65px;
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
		display: none;
	}
`
